import { CheckOutlined, CloseOutlined, KeyOutlined, LockOutlined, UserOutlined } from "@ant-design/icons";
import {
  Avatar,
  Breadcrumb,
  Empty,
  Flex,
  Input,
  message,
  Modal,
  Skeleton,
  Switch,
  Table,
  Tooltip,
} from "antd";
import { useCallback, useEffect, useState } from "react";

import { NavLink, useNavigate } from "react-router-dom";
import { adminResetShopPassword } from "../../../api/User/infoUser";
import { loadUserShop } from "../../../auth/session";
import { resetAPIWithErrorHandling } from "../../../api/reset/reset";
import { getDisplayNameFromUser } from "../../../utils/userDisplayName";
import { resolveImageUrl } from "../../../utils/image";
import { useSession } from "../../../auth/session";
import RowActions from "../../../components/cms/RowActions";
import { ACTION_ICON, confirmDelete } from "../../../components/cms/actions";
import { neutral } from "../../../theme/tokens";

export default function ListAccout() {
  const { userShop, isLoading } = useSession();
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [data, setData] = useState([]);
  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);
  const handleSizeChange = useCallback((current, size) => {
    setPageSize(size);
  }, []);

  // Đổi mật khẩu tài khoản SHOP (ADMIN)
  const [pwTarget, setPwTarget] = useState(null);
  const [pwForm, setPwForm] = useState({ password: "", confirm: "" });
  const [pwSaving, setPwSaving] = useState(false);

  const openResetPassword = (record) => {
    setPwForm({ password: "", confirm: "" });
    setPwTarget(record);
  };

  const submitResetPassword = async () => {
    if (pwSaving || !pwTarget) return;
    if (!pwForm.password || pwForm.password.length < 6) {
      message.error("Mật khẩu tối thiểu 6 ký tự");
      return;
    }
    if (pwForm.password !== pwForm.confirm) {
      message.error("Xác nhận mật khẩu không khớp");
      return;
    }
    setPwSaving(true);
    try {
      await adminResetShopPassword(pwTarget.id, pwForm.password);
      message.success(`Đã đổi mật khẩu cho "${pwTarget.name}"`);
      setPwTarget(null);
    } catch (error) {
      message.error(error?.response?.data?.message || "Đổi mật khẩu thất bại");
    } finally {
      setPwSaving(false);
    }
  };

  useEffect(() => {
    loadUserShop({ currentPage, pageSize }).catch(() => {
      // 401 do interceptor lo; lỗi khác thì giữ danh sách đang có.
    });
  }, [currentPage, pageSize]);

  useEffect(() => {
    const dataNew = userShop?.data.map((items, index) => {
      return {
        key: items.id,
        id: items.id,
        email: items.email,
        phone: items.phone,
        name: getDisplayNameFromUser(items, items.username),
        avatar: items.info.avatar,
        gender: items.info.gender,
        birth_day: items.birth_day,
        type: items.info.type,
        is_rank_reset: items.is_rank_reset,
        is_voicecall: items.is_voicecall,
        is_locked: items.is_locked,
      };
    });
    setData(dataNew);
  }, [userShop]);

  const toggleStatusResetRankPoint = async (record) => {
    try {
      await resetAPIWithErrorHandling.toggleStatusResetRankPoint(record.id);

      setData(prev => prev.map(item =>
        item.id === record.id
          ? { ...item, is_rank_reset: item.is_rank_reset === 1 ? 0 : 1 }
          : item
      ));

      message.success(`Đã thiết lập thành công "${record.name}"`);
    } catch (error) {
      message.error(error.message || "Không thể thực hiện chức năng!");
    }
  };

  const toggleStatusVoiceCall = async (record) => {
    try {
      await resetAPIWithErrorHandling.toggleStatusVoiceCall(record.id);

      setData(prev => prev.map(item =>
        item.id === record.id
          ? { ...item, is_voicecall: item.is_voicecall === 1 ? 0 : 1 }
          : item
      ));

      message.success(`Đã thiết lập thành công "${record.name}"`);
    } catch (error) {
      message.error(error.message || "Không thể thực hiện chức năng!");
    }
  };

  const toggleStatusActiveAccount = async (record) => {
    try {
      await resetAPIWithErrorHandling.toggleStatusActiveAccount(record.id);

      setData(prev => prev.map(item =>
        item.id === record.id
          ? { ...item, is_locked: item.is_locked === 1 ? 0 : 1 }
          : item
      ));

      message.success(`Đã thiết lập thành công "${record.name}"`);
    } catch (error) {
      message.error(error.message || "Không thể thực hiện chức năng!");
    }
  };
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      // fixed: 'left',
      width: 100,
    },
    {
      title: "Tên",
      dataIndex: "name",
      editable: true,
      fixed: 'left',
      width: 280,
      render: (text, record) => {
        const userAvatar = record?.avatar ? resolveImageUrl(record.avatar) : null;
        return (
          <Flex align="center">
            <Avatar
              style={{ cursor: "pointer", marginRight: "12px" }}
              size={40}
              src={userAvatar}
              icon={record?.avatar ? null : <UserOutlined />}
            />
            <span>{text}</span>
          </Flex>
        );
      },
    },
    {
      title: "Chức vụ",
      dataIndex: "type",
      align: "center",
      width: 150,
    },
    {
      title: "Số điện thoại",
      dataIndex: "phone",
      width: 150,
    },
    {
      title: "Email",
      dataIndex: "email",
      align: "center",
      width: 180,
    },
    // {
    //   title: "Ngày sinh",
    //   dataIndex: "birth_day",
    //   align: "center",
    //   width: 150,
    // },
    // {
    //   title: "Giới tính",
    //   dataIndex: "gender",
    //   align: "center",
    //   width: 130,
    //   render: (_, record) => {
    //     const checkGender =
    //       record.gender === "MALE"
    //         ? "Nam"
    //         : record.gender === "FEMALE"
    //         ? "Nữ"
    //         : record.gender === "OTHER"
    //         ? "Khác"
    //         : "";
    //     return checkGender;
    //   },
    // },
    {
      title: "Reset Hạng-Điểm",
      dataIndex: "gender",
      align: "center",
      width: 130,
      render: (_, record) => {
        const check = record.is_rank_reset === 1;

        return (
          <Switch
            checked={check}
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            onChange={() => toggleStatusResetRankPoint(record)}
          />
        );
      },
    },
    {
      title: "Voicecall",
      dataIndex: "gender",
      align: "center",
      width: 130,
      render: (_, record) => {
        const check = record.is_voicecall === 1;

        return (
          <Switch
            checked={check}
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            onChange={() => toggleStatusVoiceCall(record)}
          />
        );
      },
    },
    {
      title: "Thao tác",
      dataIndex: "operation",
      align: "center",
      width: 140,
      fixed: "right",
      render: (_, record) => (
        <Flex align="center" justify="center" gap={12}>
          <Tooltip title="Kích hoạt / Khóa">
            <Switch
              checked={record.is_locked === 0}
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
              onChange={() => toggleStatusActiveAccount(record)}
              size="small"
            />
          </Tooltip>

          <RowActions
            items={[
              {
                key: "permission",
                icon: <KeyOutlined />,
                label: "Phân quyền",
                onClick: () => navigate(`/add-permission/${record.id}`),
              },
              {
                key: "reset-password",
                icon: <LockOutlined />,
                label: "Đổi mật khẩu",
                onClick: () => openResetPassword(record),
              },
              {
                /*
                 * CHƯA KHẢ DỤNG — có chủ ý. Bản cũ hiện nút Xóa với Popconfirm
                 * nhưng KHÔNG truyền `onConfirm`, nên bấm "Xóa" xong không có gì
                 * xảy ra. Không tự ý nối vào API xóa tài khoản (hành động nặng,
                 * cần xác nhận nghiệp vụ); khóa lại để không ai tưởng đã xóa được.
                 */
                key: "delete",
                icon: ACTION_ICON.delete,
                label: "Xóa tài khoản (chưa khả dụng)",
                danger: true,
                divider: true,
                disabled: true,
                onClick: () => {},
              },
            ]}
          />
        </Flex>
      ),
    }

  ];
  return (
    <div className="list-account-shop">
      <h2>Danh sách tài khoản</h2>
      <Breadcrumb separator=">">
        <Breadcrumb.Item>
          <NavLink to="/">Home</NavLink>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <NavLink to="/list-account">Tài khoản chủ đơn vị</NavLink>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Table
        columns={columns}
        pagination={{
          showTotal: (total, range) =>
            `Hiển thị từ ${range[0]} -> ${range[1]} trong tổng ${total} giá trị`,
          showQuickJumper: true,
          showSizeChanger: true,
          onShowSizeChange: handleSizeChange,
          total: userShop?.total,
          current: currentPage,
          onChange: handlePageChange,
        }}
        loading={data?.length === 0 ? isLoading : false}
        dataSource={isLoading ? [] : data}
        locale={{
          emptyText: isLoading ? (
            <Flex vertical gap={20}>
              {[...Array(data?.length || 0)].map((_, rowIndex) => (
                <Flex gap={10} key={rowIndex}>
                  {columns.map((column) => (
                    <Skeleton.Input
                      key={`${column.dataIndex}-${rowIndex}`}
                      active={true}
                      size="small"
                      style={{ width: "95%" }}
                    />
                  ))}
                </Flex>
              ))}
            </Flex>
          ) : (
            <Empty />
          ),
        }}
        bordered
        size="small"
        scroll={{ x: "max-content" }}
      />
      {/* {open && (
        <ModalAddPermissionInUser
          isOpen={open}
          onCancel={() => setOpen(false)}
          userId={userId}
        />
      )} */}

      <Modal
        title="Đổi mật khẩu tài khoản"
        open={!!pwTarget}
        onCancel={() => !pwSaving && setPwTarget(null)}
        onOk={submitResetPassword}
        okText="Đổi mật khẩu"
        cancelText="Hủy"
        confirmLoading={pwSaving}
        destroyOnClose
      >
        <p style={{ marginBottom: 12, color: neutral[500] }}>
          Tài khoản: <b>{pwTarget?.name}</b>
          {pwTarget?.phone ? ` · ${pwTarget.phone}` : ""}
        </p>
        <Input.Password
          style={{ marginBottom: 10 }}
          placeholder="Mật khẩu mới (tối thiểu 6 ký tự)"
          value={pwForm.password}
          onChange={(e) => setPwForm((s) => ({ ...s, password: e.target.value }))}
        />
        <Input.Password
          placeholder="Nhập lại mật khẩu mới"
          value={pwForm.confirm}
          onChange={(e) => setPwForm((s) => ({ ...s, confirm: e.target.value }))}
          onPressEnter={submitResetPassword}
        />
      </Modal>
    </div>
  );
}
